<div class="auth-page">
  <div class="auth-form-side">
    <div class="auth-card">
      <div class="auth-brand auth-brand--compact">
        <div class="auth-brand__icon">
          <img src="assets/vtt-logo.png" alt="Van Tonder Transport logo" />
        </div>
        <div class="auth-brand__copy">
          <span class="auth-brand__name">VTT</span>
          <span class="auth-brand__sub">Van Tonder Transport</span>
        </div>
      </div>

      <div class="auth-heading">
        <h1>Welcome back</h1>
        <p>Sign in to continue to your fleet workspace</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="auth-form">
        <div class="auth-field">
          <div class="auth-field__label-row">
            <label for="username">Username or email</label>
            <a routerLink="/forgot-username" class="auth-link">Forgot username?</a>
          </div>
          <input
            id="username"
            pInputText
            type="text"
            formControlName="username"
            placeholder="Enter your username or email"
            class="w-full"
            [class.p-invalid]="submitted && f.username.errors"
            autocomplete="username"
          />
          <small
            class="auth-error"
            *ngIf="submitted && f.username.errors?.['required']"
          >
            Username or email is required
          </small>
        </div>

        <div class="auth-field">
          <div class="auth-field__label-row">
            <label for="password">Password</label>
            <a routerLink="/forgot-password" class="auth-link"
              >Forgot password?</a
            >
          </div>
          <input
            id="password"
            pInputText
            type="password"
            formControlName="password"
            placeholder="Enter your password"
            class="w-full"
            [class.p-invalid]="submitted && f.password.errors"
            autocomplete="current-password"
          />
          <small
            class="auth-error"
            *ngIf="submitted && f.password.errors?.['required']"
          >
            Password is required
          </small>
        </div>

        <p-message
          *ngIf="error"
          severity="error"
          text="Invalid username or password. Please try again."
          styleClass="w-full"
        ></p-message>

        <button
          pButton
          pRipple
          type="submit"
          label="Sign In"
          icon="pi pi-arrow-right"
          iconPos="right"
          [loading]="loading"
          class="w-full p-button-primary auth-submit"
        ></button>
      </form>
    </div>
  </div>

  <div class="auth-showcase">
    <div class="auth-showcase__mark">
      <span class="auth-showcase__mark-icon"><img src="assets/vtt-logo.png" alt="Van Tonder Transport logo" /></span>
      <span class="auth-showcase__mark-text">VTT</span>
    </div>

    <div class="auth-showcase__copy">
      <span class="auth-showcase__eyebrow">Fleet Operations</span>
      <h2>Keep every vehicle accounted for.</h2>
      <p>
        Active issues, service history, and technical records for your whole
        fleet, in one workspace.
      </p>
    </div>

    <div class="auth-showcase__foot">Van Tonder Transport</div>

    <i class="pi pi-truck auth-showcase__watermark" aria-hidden="true"></i>
  </div>
</div>
